import * as React from 'react';
import AdminTabs from './AdminTabs';
import { RedirectAs404 } from 'src/utils/RouteErrors';
import { Route, Switch } from 'react-router-dom';
import { BreadcrumbsItem } from '../shared/GlobalBreadcrumb';
import Routes from 'src/consts/Routes';
import RoleUtil from 'src/utils/RoleUtil';

const Admin = () => (
    <React.Fragment>
        <BreadcrumbsItem name="admin" to={Routes.generate(Routes.ADMIN)} iconName="document">Admin</BreadcrumbsItem>
        <Switch>
            <Route path={Routes.ADMIN + '/:tabId'} render={(props) => <AdminTabs {...props} tab={parseInt(props.match.params.tabId!)}/>} />
            <Route path="/admin" component={AdminTabs} />

            {/* This needs to be the last item */}
            <Route component={RedirectAs404} />
        </Switch>
    </React.Fragment>
);

export default Admin;
